// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k5TW","textarea":"styles_textarea__2OCEK"};